import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './topbar.module.scss';


type ComponentProps = {
    className?: string;
} & HTMLAttributes<HTMLDivElement>

export function TopbarActions ({ className, ...props }: ComponentProps) {
    return (
        <div
            className={ cn(styles.actions, className) }
            { ...props }
        />
    );
}
